export default "__VITE_ASSET__BmoZYIpl__"